import actions from 'src/modules/interaction/view/interactionViewActions';
import interactionMeetingNotesActions from 'src/modules/interaction/shared/interactionMeetingNotesActions';

const initialData = {
  loading: false,
  record: null,
};

export default (state = initialData, { type, payload }) => {
  if (type === actions.FIND_STARTED) {
    return {
      ...state,
      record: null,
      loading: true,
    };
  }

  if (type === actions.FIND_SUCCESS) {
    return {
      ...state,
      record: payload,
      loading: false,
    };
  }

  if (type === actions.FIND_ERROR) {
    return {
      ...state,
      record: null,
      loading: false,
    };
  }

  if (type === interactionMeetingNotesActions.ADD_NOTE_SUCCESS) {
    return {
      ...state,
      record: payload,
      loading: false,
    };
  }

  if (type === interactionMeetingNotesActions.ADD_NOTE_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === interactionMeetingNotesActions.UPDATE_NOTE_SUCCESS) {
    return {
      ...state,
      record: payload,
      loading: false,
    };
  }

  if (type === interactionMeetingNotesActions.UPDATE_NOTE_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === interactionMeetingNotesActions.DELETE_NOTE_SUCCESS) {
    return {
      ...state,
      record: payload,
      loading: false,
    };
  }

  if (type === interactionMeetingNotesActions.DELETE_NOTE_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  return state;
};
